import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .search-bar {
    margin: 8px 16px 8px 16px;
  }
`

export const NavBarContainer = styled.div`
  padding: 0 16px;
  box-sizing: border-box;
`

export const SearchBarContainer = styled.div`
  padding: 0 16px;
  box-sizing: border-box;
`

export const ScrollContainer = styled.div`
  height: 540px;
  overflow-y: scroll;
`

export const GapContainer = styled.div`
  padding: 8px 16px;
  box-sizing: border-box;
`

export const SectionLabel = styled.div`
  position: sticky;
  top: 0;
  left: 0;

  padding: 11px 16px;
  box-sizing: border-box;

  background: var(--Background-Neutral-faded, #f3f4f6);

  color: var(--Foreground-Neutral-faded, #4d5874);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 11px; /* 78.571% */
`
